import api from "../../index";

// Types
interface Smtp {
  name: string;
  host: string;
  port: number;
  secure: boolean;
  apiEndpoint: string;
  apiKey: string;
  status: "active" | "inactive" | "error";
  lastHealthCheck?: Date;
  errorLog: Array<{
    error: string;
    timestamp: Date;
  }>;
  maxQuota: number;
  currentLoad: number;
}

interface SmtpCreateInput {
  name: string;
  host: string;
  port: number;
  secure?: boolean;
  apiEndpoint: string;
  apiKey: string;
  maxQuota?: number;
}

interface SmtpUpdateInput {
  name?: string;
  host?: string;
  port?: number;
  secure?: boolean;
  apiEndpoint?: string;
  apiKey?: string;
  status?: "active" | "inactive" | "error";
  maxQuota?: number;
}

// --------- SMTP API --------- //

// Create an SMTP server
export const createSmtp = async (values: SmtpCreateInput) => {
  return await api.post<Smtp>("/smtp", values);
};

// Get all SMTP servers
export const getAllSmtp = async () => {
  return await api.get<Smtp[]>("/smtp");
};

// Get all SMTP servers paginated
export const getSmtpPaginated = async (
  page: number,
  perPage: number,
  searchText?: string
) => {
  const searchParams = new URLSearchParams({
    page: page.toString(),
    perPage: perPage.toString(),
    ...(searchText && { searchText }),
  });

  return await api.get(`/smtp-paginated?${searchParams.toString()}`);
};

// Get active SMTP servers
export const getActiveSmtp = async () => {
  return await api.get<Smtp[]>("/smtp-active");
};

// Get an SMTP server by ID
export const getSmtpById = async (id: string) => {
  return await api.get<Smtp>(`/smtp/${id}`);
};

// Update an SMTP server by ID
export const updateSmtpById = async (id: string, values: SmtpUpdateInput) => {
  return await api.put<Smtp>(`/smtp/${id}`, values);
};

// Delete an SMTP server by ID
export const deleteSmtpById = async (id: string) => {
  return await api.delete(`/smtp/${id}`);
};

// Update SMTP server status
export const updateSmtpStatus = async (
  id: string,
  status: "active" | "inactive" | "error"
) => {
  return await api.put<Smtp>(`/smtp/${id}/status`, { status });
};

// Update SMTP server health check
export const updateSmtpHealthCheck = async (id: string) => {
  return await api.put<Smtp>(`/smtp/${id}/health-check`);
};
